import { Modal } from './types';

export const SET_CMS_RESOURCE = 'cms/SET_CMS_RESOURCE';

export type SetCmsResourceAction = {
	type: typeof SET_CMS_RESOURCE;
	payload: {
		modals: Modal[];
		lastFetched: number | null;
	};
};

export const setCmsResource = ({
	modals,
	lastFetched,
}: {
	modals: Modal[];
	lastFetched: number | null;
}): SetCmsResourceAction => ({
	type: SET_CMS_RESOURCE,
	payload: {
		modals,
		lastFetched,
	},
});
